// ----------------------------------------------------------------------
// <copyright file="Izenda.ScheduleConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//

/**
 * ScheduleConstants
 */

import localizer from 'share/localization/Izenda.Localizer';

const DAYOFWEEK = {
  SUNDAY: 1,
  MONDAY: 2,
  TUESDAY: 3,
  WEDNESDAY: 4,
  THURSDAY: 5,
  FRIDAY: 6,
  SATURDAY: 7
};

export default {
  DAYOFWEEK,
  //TODO: Not apply localization, need to fix line 88 in Izenda.RecurrencePattern.jsx
  RECURRENCE_PATTERN: [
    { value: 0, label: 'daily' },
    { value: 1, label: 'weekly' },
    { value: 2, label: 'monthly' },
    { value: 3, label: 'yearly' }
  ],

  RECURRENCE_REPORTLIST: [
    {
      value: '2',
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_DATE');
      }
    },
    {
      value: '3',
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_WEEKDAY');
      }
    },
    {
      value: '4',
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_WEEK');
      }
    },
    {
      value: '5',
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_TWO_WEEK');
      }
    },
    {
      value: '6',
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_MONTH');
      }
    },
    {
      value: '7',
      get label() {
        return localizer.getText('COMMON_LABEL_EVERY_QUARTER');
      }
    },
    {
      value: '8',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_RECURRENCE_REPORTLIST_CUSTOM_RECURRENCE');
      }
    }
  ],

  RECURRENCE_ALERTLIST: [
    {
      value: '0',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_RECURRENCE_ALERTLIST_ALERT_HOURLY');
      }
    },
    {
      value: '1',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_RECURRENCE_ALERTLIST_ALERT_DAILY');
      }
    },
    {
      value: '8',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_RECURRENCE_REPORTLIST_CUSTOM_RECURRENCE');
      }
    }
  ],

  ORDINAL_LIST: [
    {
      value: '1',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_ORDINAL_LIST_FIRST');
      }
    },
    {
      value: '2',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_ORDINAL_LIST_SECOND');
      }
    },
    {
      value: '3',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_ORDINAL_LIST_THIRD');
      }
    },
    {
      value: '4',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_ORDINAL_LIST_FOURTH');
      }
    },
    {
      value: '100',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_ORDINAL_LIST_LAST');
      }
    }
  ],

  //TODO: Not apply localization, need to fix line 66 in Izenda.SubscriptionDetails.jsx
  DAYNAME_LIST: [
    { value: DAYOFWEEK.SUNDAY, label: 'Sunday' },
    { value: DAYOFWEEK.MONDAY, label: 'Monday' },
    { value: DAYOFWEEK.TUESDAY, label: 'Tuesday' },
    { value: DAYOFWEEK.WEDNESDAY, label: 'Wednesday' },
    { value: DAYOFWEEK.THURSDAY, label: 'Thursday' },
    { value: DAYOFWEEK.FRIDAY, label: 'Friday' },
    { value: DAYOFWEEK.SATURDAY, label: 'Saturday' }
  ],

  MONTHNAME_LIST: [
    {
      value: '1',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_JANUARY');
      }
    },
    {
      value: '2',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_FEBRUARY');
      }
    },
    {
      value: '3',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_MARCH');
      }
    },
    {
      value: '4',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_APRIL');
      }
    },
    {
      value: '5',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_MAY');
      }
    },
    {
      value: '6',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_JUNE');
      }
    },
    {
      value: '7',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_JULY');
      }
    },
    {
      value: '8',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_AUGUST');
      }
    },
    {
      value: '9',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_SEPTEMBER');
      }
    },
    {
      value: '10',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_OCTOBER');
      }
    },
    {
      value: '11',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_NOVEMBER');
      }
    },
    {
      value: '12',
      get label() {
        return localizer.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_DECEMBER');
      }
    }
  ],
  DATE_SIMPLE_FORMAT: 'MM/DD/YYYY',
  DEFAULT_OCCURRENCE: 1
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ScheduleConstants.js